import { render, staticRenderFns } from "./zTableItems.vue?vue&type=template&id=5934051d&scoped=true&"
import script from "./zTableItems.vue?vue&type=script&lang=js&"
export * from "./zTableItems.vue?vue&type=script&lang=js&"
import style0 from "./zTableItems.vue?vue&type=style&index=0&id=5934051d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5934051d",
  null
  
)

export default component.exports